import GeofencesUpdateApp from "../../../../../Traffic/Manage/Functionality/GeofencesUpdateApp";
import HeadTittle from "../../../../../../../components/HeadTittle";
import {permissionObj} from "../../../../../../../Helpers/permission";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import DividerWithText from "../../../../../../../components/DividerWithText";
import ActiveScheduleStep from "../../../../../Traffic/Manage/SubComponents/ActiveSheduleStep";
import DefineAreaStep from "../../../../../Traffic/Manage/SubComponents/DefineAreaStep";
import {UpdateGeofenceAttendance} from "../Functionality/UpdateGeofenceAttendance";
import DetailsStep from "./DetailsStep";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 01 de 2026
 */

const UpdateGeoFenceAttendance  = () => {
    const {
        t,
        DEV,
        item,
        disabled,
        permission,
        emptyFields,
        setItem,
        setDayArray,
        dayArray,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        center,
        handleUpdate,
        handleOnBack,
        isCloseTimeInvalid,
        selectedList,
        setSelectedList
    } = UpdateGeofenceAttendance();

    return (
        <>
            <HeadTittle name={disabled ? 'details' : 'update'} onBack={handleOnBack}>
                {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_UPDATE)) &&
                <ButtonAction
                    id='btn_uga_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handleUpdate();
                    }}
                />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('details')} />
                </div>

                <DetailsStep
                    t={t}
                    item={item}
                    setItem={setItem}
                    disabled={disabled}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                />
                <div className='col-12 my-4'>
                    <DividerWithText title={t('active_schedule')} />
                </div>

                <ActiveScheduleStep
                    item={item}
                    t={t}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    dayArray={dayArray}
                    setDayArray={setDayArray}
                    setItem={setItem}
                    disabled={disabled}
                    isCloseTimeInvalid={isCloseTimeInvalid}
                    formatValue={false}

                />
                <div className='col-12 mb-4'>
                    <DividerWithText title={t('geofence_area')} />
                </div>
                <div className={'col-12 mb-4'}>
                    <DefineAreaStep
                        t={t}
                        geofences={geofences}
                        setGeofences={setGeofences}
                        latitude={latitude}
                        setLatitude={setLatitude}
                        longitude={longitude}
                        setLongitude={setLongitude}
                        emptyFields={emptyFields}
                        item={item}
                        setItem={setItem}
                        center={center}
                        disabled={disabled}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};
export default UpdateGeoFenceAttendance
